module.exports = __webpack_public_path__ + "static/media/trademark.ed9d8ea8.jpg";